import React, { Component } from 'react'
import { ButtonSecondary } from '../components/Buttons'
import './RowView.css'

class RowView extends Component {
  constructor (props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
  }
  handleClick (ev) {
    ev.preventDefault()
    this.props.history.push('/view/' + this.props.id)
  }
  render () {
    return (
      <div className='row_view'>
        <div className='row_view__data'>
          <h4 className='row_view__title'>{this.props.titulo}</h4>
          <p className='row_view__meta'>
            {this.props.active ? <span className='active'>Activa</span> : <span>Finalizada</span>}
          </p>
        </div>
        <div className='row_view__actions'>
          <ButtonSecondary
            label='Consultar'
            onClick={this.handleClick}
            sm
          />
        </div>
      </div>
    )
  }
}

export default RowView
